import { FC } from "react";

import { MazakaSelect } from "apps/Common/MazakaSelect";
import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";
import useCapitalize from "../Adress/helpers/useCapitalize";
import { useGetAlarmWays } from "./ServerSideStates";


const GeneralNotificationTypes: FC<GeneralSelectInputs> = (props) => {
  const notificationTypes= useGetAlarmWays()
  let { capitalize } = useCapitalize();

  return (
    <>
      <MazakaSelect
        name={props.name}
        xs={props.xs}
        sm={props.sm}
        md={props.md}
        lg={props.lg}
        xl={props.xl}
        loading={notificationTypes.isLoading || notificationTypes.isFetching}
        disabled={notificationTypes.isLoading || notificationTypes.isFetching || props.disabled}
        className={props.className}
        showSearch={true}
        allowClear={props.allowClear || false}
        filterOption={(input, option: any) =>
          (option.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        label={props.label}
        options={
          notificationTypes?.data?.data
            ? notificationTypes.data.data.map((item: any) => {
                return {
                  key: item.id,
                  value: item.id,
                  label: capitalize(item.name || " "),
                };
              })
            : []
        }
        placeholder={props.placeholder}
        mode={props.mode}
        onChange={props.onChange}
        value={props.value}
        rules={props.rules}
      />
    </>
  );
};

export default GeneralNotificationTypes;
